module.exports = mapSymbol

var map = require('./map')

function mapSymbol(currencyCode) {
  if (map.hasOwnProperty(currencyCode)) {
    return map[currencyCode]
  } else {
    return '?'
  }
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/currency-symbol-map/currency-symbol-map.js
 ** module id = 2561
 ** module chunks = 0
 **/